<template>
    <div class="row">
        <div class="col-md-6">
            <punjab-map></punjab-map>
        </div>
        <div class="col-md-6">
            <kpk-map></kpk-map>
        </div>
        
        <div class="col-md-6">
            <sindh-map></sindh-map>
        </div>
        <div class="col-md-6">
            <balochistan-map></balochistan-map>
        </div>
    </div>
</template>

<script>
import BalochistanMap from './BalochistanMap.vue'
import KPKMap from './KPKMap.vue'
import PunjabMap from './PunjabMap.vue'
import SindhMap from './SindhMap.vue'
    export default {
        components: { PunjabMap, SindhMap, BalochistanMap, 'kpk-map' : KPKMap },
        name: 'provinces-map', 
        data() {
            return {

            }
        },
    }
</script>

<style lang="scss" scoped>
.shape{
  fill: rgb(30, 223, 197);
}
</style>